import {
    FETCH_LABO_CASES,
    FETCH_LABO_CASE_DETAIL,
    CREATE_LABO_CASE,
    UPDATE_LABO_CASE,
    DELETE_LABO_CASES,
    FETCH_LABO_CASE_STATUS_STATISTICS,
    FETCH_LABO_CASE_CUSTOMER_STATISTICS
} from '@/redux/actions/types';

/**
 * Trạng thái khởi tạo cho module Labo
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    detail: null,
    createResult: null,
    updateResult: null,
    deleteResult: null,
    statusStatistics: {},
    customerStatistics: {}
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_LABO_CASES: {
            return {
                ...state,
                list: {
                    items: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    }
                }
            };
        }

        case FETCH_LABO_CASE_DETAIL: {
            return {
                ...state,
                detail: action.payload || null
            };
        }

        case CREATE_LABO_CASE: {
            return {
                ...state,
                createResult: action.payload || null
            };
        }

        case UPDATE_LABO_CASE: {
            return {
                ...state,
                updateResult: action.payload || null
            };
        }

        case DELETE_LABO_CASES: {
            return {
                ...state,
                deleteResult: action.payload || null
            };
        }
        case FETCH_LABO_CASE_STATUS_STATISTICS:
            return { ...state, statusStatistics: action.payload };
        case FETCH_LABO_CASE_CUSTOMER_STATISTICS:
            return { ...state, customerStatistics: action.payload };

        default:
            return state;
    }
};
